module.exports = __webpack_public_path__ + "static/media/gucci-bamboo-big.dcac4727.png";